// extracted by mini-css-extract-plugin
export default {"container":"nav-module__container--4-agB"};